var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchoolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9b9a9a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.71,10.25H13.81v-3.67l6.81-3.13c.14-.06,.14-.26,0-.32L13.81,0h-2.14c-.11,0-.2,.09-.2,.2V10.25H1.29c-.71,0-1.29,.58-1.29,1.29v13.46H9.92v-4.04c0-1.42,1.15-2.58,2.58-2.58s2.58,1.15,2.58,2.58v4.04h9.92V11.54c0-.71-.58-1.29-1.29-1.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIcon);
export default __webpack_public_path__ + "static/media/SchoolIcon.85cb2e83f1394d519189e4c7fa38d13a.svg";
export { ForwardRef as ReactComponent };